(function () {
  const LIMIT = 6;

  function initFacetShowMore() {
    const form = document.querySelector("#FacetFiltersForm");
    if (!form) return;

    const filters = form.querySelectorAll(".js-filter");

    filters.forEach((filterBlock) => {
      const list = filterBlock.querySelector('ul[role="list"]');
      if (!list) return;

      // remove old button if exists
      const oldBtn = filterBlock.querySelector(".facet-show-more-btn");
      if (oldBtn) oldBtn.remove();

      const items = Array.from(list.querySelectorAll("li"));
      if (items.length <= LIMIT) return;

      let expanded = false;

      items.forEach((item, index) => {
        item.style.display = index >= LIMIT ? "none" : "";
      });

      const button = document.createElement("button");
      button.type = "button";
      button.className = "facet-show-more-btn";
      const isArabic = document.documentElement.lang === "ar";
      const translations = {
        showMore: isArabic ? "عرض المزيد" : "Show more",
        showLess: isArabic ? "عرض أقل" : "Show less"
      };

      button.textContent = translations.showMore;

      button.addEventListener("click", () => {
        expanded = !expanded;
        items.forEach((item, index) => {
          if (index >= LIMIT) item.style.display = expanded ? "block" : "none";
        });
        button.textContent = expanded ? translations.showLess : translations.showMore;
      });

      list.parentElement.appendChild(button);
    });
  }

  // expose globally so Alpine can call it after ajax render
  window.initFacetShowMore = initFacetShowMore;

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initFacetShowMore, 300);
  });

  document.addEventListener("shopify:section:load", () => {
    setTimeout(initFacetShowMore, 50);
  });

  // ✅ our own custom event (we will trigger it after filters ajax update)
  document.addEventListener("facets:rendered", () => {
    setTimeout(initFacetShowMore, 10);
  });
})();